import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
// import {scale} from 'd3'
import * as d3 from "d3";
// import { scaleLinear, scaleBand, select } from "d3";
const agerepChartFunc = (divRef, ndx) => {
  // wrapping x-ticks lable texts

  function wrap(text_orig, width) {
    text_orig.each(function (x) {
      //Array.prototype.forEach.call(text_orig._groups[0], function (x) {
      var text = d3.select(this);
      var all_tspans = text.selectAll("tspan").size();
      
      if (all_tspans > 1) {
        return;
      }

      var words = text.text().split(/\s+/).reverse();
      var word;
      var lineNumber = 0;
      var lineHeight = 1.1; // ems
      var y = text.attr("y");
      var dy = parseFloat(text.attr("dy"));
      var tspan = text
        .text(null)
        .append("tspan")
        .attr("x", 0)
        .attr("y", y)
        .attr("dy", dy + "em");

      while ((word = words.pop())) {
        tspan = text
          .append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", lineNumber * lineHeight + dy + "em")
          .text(word);
        ++lineNumber;
      }
    });
  }
  function remove_empty_bins(source_group) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
          return d.value !== 0; // if integers only
        });
      },
    };
  }
    const dimension = ndx.dimension((d) => d.type_of_Investment_Opportinities);

  const dealCountGrp = dimension.group().reduceCount();

  const recipChart = dc.barChart(divRef);

  recipChart
    .width(290)
    .height(200)
    .x(d3.scaleBand())
    .margins({ left: 0, top: 0, right: 0, bottom: 40 })
    .xUnits(dc.units.ordinal)
    // .elasticX(true)
    .brushOn(false)
    .dimension(dimension)
    .barPadding(0.1)
    .outerPadding(0.05)
    .transitionDuration(1500)
    // .margins({ bottom: 10 })
    .group(dealCountGrp)
    .colors(["#327E73"])
    .on("renderlet", function (d) {
      recipChart.selectAll("g.x.axis .tick text").call(wrap, 1);
    })

    // console.log(sizeChart.selectAll(".tick"));
    // .selectAll(".tick text")
    // .call(wrap, d3.scaleBand().bandwidth());

    .renderlet((chart) => {
      var gLabels = chart.select(".labels");
      if (gLabels.empty()) {
        gLabels = chart
          .select(".chart-body")
          .append("g")
          .classed("labels", true);
      }

      var gLabelsData = gLabels.selectAll("text").data(chart.selectAll(".bar"));
      gLabelsData.exit().remove(); //Remove unused elements

      gLabelsData.enter().append("text"); //Add new elements

      gLabelsData
        .attr("text-anchor", "middle")
        .attr("fill", "white")
        .text(function (d) {
          return d3.select(d).data()[0].data.value;
        })
        .attr("x", function (d) {
          return +d.getAttribute("x") + d.getAttribute("width") / 2;
        })
        .attr("y", function (d) {
          return +d.getAttribute("y") + 15;
        })
        .attr("style", function (d) {
          if (+d.getAttribute("height") < 10) return "display:none";
        });
    });
  recipChart.yAxis().ticks(0);

  return recipChart;
};

export const AgeOfRecipient = (props) => (
  <ChartTemplate
    chartFunction={agerepChartFunc}
    title="Type of Investement Opportunities"
  />
);
